import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id B7DB5F20-5D64-4096-959F-60BB040B320F
 * name camera-rear-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-rear-variant.svg
 * tags
 * - Photography 
 */
export const CameraRearVariantIcon = createSvgIcon(<><path d="M6,0H18A2,2 0 0,1 20,2V22A2,2 0 0,1 18,24H6A2,2 0 0,1 4,22V2A2,2 0 0,1 6,0M12,2A2,2 0 0,0 10,4A2,2 0 0,0 12,6A2,2 0 0,0 14,4A2,2 0 0,0 12,2M13,18H9V20H13V22L16,19L13,16V18Z" /></>, 'CameraRearVariantIcon');
export default CameraRearVariantIcon